import moment from "moment";
import { rqx } from "../../core/request/API";
import { env } from "../../core/Env";
import sha1 from "js-sha1";

export const ProductUbr = async(data, ainfo) => {
    const d = await rqx.get(`<<hrc>>/${env()}/template/view`, {id: data.pid})
    let body;
    
    const TotalAmount = () => {
        const subTotal = parseFloat(d.data[0].total_rate) * parseFloat(data.inputs.quantity)
        const shippingFee = Number(data.inputs.shipping_fee)
        let totalPrice = subTotal + parseFloat(shippingFee ? shippingFee : 0)
        if (data.discount_details.length > 0) {
            if (data.discount_details[0].discount_type === 1) {
                let final_amount = totalPrice - parseFloat(data.discount_details[0].discount_value)
                return final_amount.toFixed(2)
            } else {
                let discountAmount = (totalPrice * parseFloat(data.discount_details[0].discount_value)) / 100;
                let final_amount = totalPrice - discountAmount
                return final_amount.toFixed(2)
            }
        } else {
            return totalPrice.toFixed(2)
        }
        // if (data.inputs.payment_opt === "full") {
        //     let sum = data.inputs.total_amount
        //     return sum.toFixed(2)
        // }else{
        //     let sum = parseInt(d.data[0].partial_payment_amount)
        //     return sum.toFixed(2)
        // }
    }
    const paymentFee = () => {
        let val;
        if (data.inputs.payment_method === 'GCSH') {
            let final_amount = data.inputs.payment_opt === 'full' ? TotalAmount() : d.data[0].partial_payment_amount
            val = (final_amount * 0.02) + 10
        }else{
            val = 10
        }
        return val
    }

    const paymentChannel = () => {
        if (data.inputs.payment_method === 'GCSH') {
            return 7
        }else{
            return 15
        }
    }

    let delivery_info_id = null;
    const userId = parseInt(window.atob(ainfo.aid).split('_')[1]);
    const isDelivery = data.inputs.delivery_option === 'delivery';

    const deliveryInfoData = {
        user_id: userId,
        first_name: data.inputs.first_name,
        last_name: data.inputs.last_name,
        contact_number: data.inputs.contact_number,
        email: data.inputs.email,
        delivery_option: isDelivery ? 1 : 0,
        is_default: isDelivery ? 1 : 0
    };

    if (isDelivery) {
        deliveryInfoData.full_address = data.inputs.address;
        deliveryInfoData.place_id = data.inputs.place_id;
        deliveryInfoData.landmark = data.inputs.landmark || '';
    }

    const response = await rqx.post(`<<tool>>/${env()}/product/create_delivery_info`, deliveryInfoData);
    if (response.message === 'success') {
        delivery_info_id = response.delivery_info_id;
    } else {
        return;
    }

    body = {
        quantity: data.inputs.quantity,
        remarks: data.inputs.remarks, 
        total_amount: data.inputs.total_amount,
        product_amount: parseFloat(d.data[0].total_rate),
        delivery_option: isDelivery ? 1 : 0,
        promo_id: data.pid,
        user_id: userId,
        status: 1,
        delivery_info_id: delivery_info_id,
        shipping_fee: Number(data.inputs.shipping_fee),
        delivery_pickup_info_id: d.data[0].delivery_pickup_info_id,
        payment_fee: paymentFee(),
        payment_channel_id: paymentChannel()
    }

    if (isDelivery) {
        body.date = moment(data.inputs.date).format('MM-DD-YYYY');
        body.time = data.inputs.time;
    } else {
        body.pickup_date = moment(data.inputs.pickup_date).format('MM-DD-YYYY');
        body.pickup_time = data.inputs.pickup_time;
    }

    const res = await rqx.post(`<<tool>>/${env()}/product/create`, body)
    if (res.message === 'success') {
        let params = {
            'merchantid': 'I4ONE2',
            'txnid': (Math.random() + 1).toString(36).substring(7),
            'amount': TotalAmount(),
            'ccy': 'PHP',
            'description': `From : ${data.inputs.first_name} ${data.inputs.last_name}`,
            'email': data.inputs.email
        }

        let d = {...params, key: env() === 'prod' ? '8dUtLoysr7A95pH' : 'rCPAaSbFmHAkoav'}
        let digest = ''
        for (const i in d) {
            if (digest === '') {
                digest = `${d[i]}`
            }else{
                digest = `${digest}:${d[i]}`
            }
        }
        let payment_option = data.inputs.payment_opt === 'full' ? 1 : 2
        let dfinal = {...params, 'param1': encodeURIComponent(JSON.stringify({cb:data.inputs.delivery_option === 'delivery' ? 'products_del' : 'products_pickup', payment_fee: paymentFee(), 'payment_channel': paymentChannel(), aid: parseInt(window.atob(ainfo.aid).split('_')[1])})), 'param2': encodeURIComponent(JSON.stringify({oid: res.order_id, payment_type: payment_option, promo_id: data.pid, tool_id: process.env.REACT_APP_TID_PSL, post_id: data.post_id, v: data.v, sharer_id: data.sharer_id,})), digest: sha1(digest)}
        let subqsp = []
        Object.keys(dfinal).map(k => subqsp.push(`${k}=${encodeURIComponent(dfinal[k])}`));
        let qsp = `${subqsp.join('&')}`
        const url = env() === 'prod' ? `https://gw.dragonpay.ph/Pay.aspx?${qsp}` : `https://test.dragonpay.ph/Pay.aspx?${qsp}`;
        window.location.href = url;
    }
}
